import { fetch } from "@/helpers/fetch"; //引用fetch.js
/**
 * get
 * -------------------------------------获取亮点工作结果---------------------------------------------
 *  sessionId 会话id
 */
export function getShineWorkResult(data) {
    return fetch({
        url: '/api/shinework/result',
        method: 'get',
        params: data
    })
}
